import { inject, ref, reactive, onActivated, onDeactivated } from 'vue';
import { useStore } from 'vuex';
import { routerPush } from '@/router';
import ApiService from '@/services/api.service';
import { AUTH_REGISTER } from "@/store/actions.type";
export default {
  name: 'Register',

  setup() {
    const store = useStore();
    const logger = inject('logger');
    const componentState = reactive({
      isLoading: false,
      isRendered: false
    });
    onActivated(() => {
      componentState.isRendered = true;
    });
    onDeactivated(() => {
      componentState.isRendered = false;
    });
    const formState = reactive({
      step: 1,
      isFormValidating: false,
      isFormDone: false
    });
    const validationRules = {
      activation_key: [{
        required: true,
        message: "Klucz aktywacyjny jest wymagany aby przejść dalej.",
        trigger: "blur"
      }, {
        len: 32,
        message: "Klucz aktywacyjny musi mieć długość dokładnie 32 znaków.",
        trigger: "blur"
      }, {
        asyncValidator: (rule, value) => {
          if (!formState.isFormValidating) return;
          return new Promise((resolve, reject) => {
            ApiService.post('auth/validation/key', {
              activation_key: value
            }).then(response => {
              Object.assign(credentials, response.data);
              resolve();
            }).catch(() => {
              reject('Wprowadzony klucz aktywacyjny nie istnieje.');
            });
          });
        },
        trigger: "blur"
      }],
      login: [{
        required: true,
        message: "Nazwa użytkownika jest wymagana",
        trigger: "blur"
      }, {
        min: 2,
        message: "Nazwa użytkownika musi posiadać przynajmniej dwa znaki",
        trigger: "blur"
      }, {
        max: 30,
        message: "Nazwa użytkownika może posiadać maksymalnie 30 znaków",
        trigger: "blur"
      }, {
        validator: (rule, value, callback) => {
          if (/^[a-z0-9_]*$/i.test(value)) callback();else callback(new Error("Nazwa użytkownika może zawierać litery bez znaków diaktrycznych, cyfry oraz znak \"_\""));
        },
        trigger: "blur"
      }, {
        asyncValidator: (rule, value) => {
          if (!formState.isFormValidating) return;
          return new Promise((resolve, reject) => {
            ApiService.post('auth/validation/login', {
              activation_key: credentials.activation_key,
              login: value
            }).then(() => {
              resolve();
            }).catch(() => {
              reject('Podany login jest już zajęty.');
            });
          });
        },
        trigger: "blur"
      }],
      email: [{
        required: true,
        message: 'Adres email jest wymagany',
        trigger: 'blur'
      }, {
        type: 'email',
        message: 'Wprowadź poprawny adres email',
        trigger: 'blur'
      }, {
        min: 3,
        message: "Adres email musi posiadać przynajmniej trzy znaki",
        trigger: "blur"
      }, {
        max: 254,
        message: "Adres email może posiadać maksymalnie 254 znaki",
        trigger: "blur"
      }, {
        asyncValidator: (rule, value) => {
          if (!formState.isFormValidating) return;
          return new Promise((resolve, reject) => {
            ApiService.post('auth/validation/email', {
              activation_key: credentials.activation_key,
              email: value
            }).then(() => {
              resolve();
            }).catch(() => {
              reject('Podany adres email jest już zajęty.');
            });
          });
        },
        trigger: "blur"
      }],
      password: [{
        required: true,
        message: "Hasło jest wymagane",
        trigger: "blur"
      }, {
        min: 6,
        message: "Hasło musi posiadać przynajmniej 6 znaków",
        trigger: "blur"
      }, {
        max: 128,
        message: "Hasło może posiadać maksymalnie 128 znaków",
        trigger: "blur"
      }],
      password_confirmation: [{
        validator: (rule, value, callback) => {
          if (value === '') callback(new Error('Wprowadź ponownie hasło'));else if (value !== credentials.password) callback(new Error("Podane hasła nie zgadzają się"));else callback();
        },
        trigger: "blur"
      }]
    };
    const credentialsForm = ref();
    const credentials = reactive({
      activation_key: '',
      login: '',
      email: '',
      password: '',
      password_confirmation: ''
    });

    function validateCredentials() {
      componentState.isLoading = true;
      formState.isFormValidating = true;
      credentialsForm.value.validate(valid => {
        formState.isFormValidating = false;
        componentState.isLoading = false;
        if (!valid) return;
        if (formState.step == 3) registerAccount();else formState.step += 1;
      });
    }

    function registerAccount() {
      componentState.isLoading = true;
      store.dispatch(AUTH_REGISTER, credentials).then(() => {
        formState.isFormDone = true;
        formState.step = 4;
      }).catch(error => {
        logger(error, 'warn');
      }).finally(() => componentState.isLoading = false);
    }

    return {
      componentState,
      formState,
      validationRules,
      credentialsForm,
      credentials,
      validateCredentials,
      routerPush
    };
  }

};